export {default} from './BrandSearchAutocomplete';
export * from './BrandSearchAutocomplete';
